// Research-gate funnel events (gate_view / eligibility_yes / eligibility_no) to gtag + dataLayer.
export function trackGateEvent(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    const { gate_display: display, ...rest } = params;
    if (typeof window.gtag === "function") {
      window.gtag("event", event, {
        event_category: "eligibility",
        event_label: "research_eligibility_gate",
        ...rest,
        ...(display ? { gate_display: display } : {}),
      });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, gate: "research_eligibility", ...(display ? { gate_display: display } : {}) });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`${event} analytics dispatch failed:`, err);
  }
}
